
const Hashtagtable = ({ hashTags, srStartCount, setselectedPopupTag }) => {
  const handleOnclickOfHashtag = (e) => {
    const hashtag = e.target.parentNode.id
    setselectedPopupTag(hashtag)
  }

  return <div className="flex justify-center w-full max-h-[74vh] overflow-y-auto">
    <table className="border w-3/5">
      <thead className="h-10">
        <tr className="border-b bg-slate-100 sticky top-0 h-0">
          <th className="text-center px-4 h-10">No.</th>
          <th className="text-center px-4 h-10">Hashtag</th>
          <th className="text-center px-4 h-10">Count</th>
        </tr>
      </thead>
      <tbody>
        {hashTags.map((hashtag, i) => <tr key={hashtag.hashtag} className="odd:bg-slate-50 group " onClick={handleOnclickOfHashtag} id={hashtag.hashtag}>
          <td className="text-center py-1">{srStartCount + i + 1}</td>
          <td className="text-center py-1 text-blue-500 group-hover:text-blue-600 cursor-pointer">#{hashtag.hashtag}</td>
          <td className="text-center py-1">{hashtag.count}</td>
        </tr>)}
      </tbody>
    </table>
  </div>

}

export default Hashtagtable
